import { ItemNutritionInformation } from 'features/menu/components/product-detail/product-nutrition-information/item-nutrition-information';
import { useComboNutritionItems } from 'features/menu/components/product-detail/product-nutrition-information/use-combo-nutrition-items';

import { Box } from 'components/ui';

export const ComboNutritionInformation = () => {
  const comboItems = useComboNutritionItems();

  return (
    <Box>
      {comboItems.map(item => (
        <ItemNutritionInformation key={item.id} item={item} />
      ))}
    </Box>
  );
};
